export const customMarkdownRenderer = {
  listitem: (text: string) => {
    const innerText = text
      .replaceAll(/<p>/gim, '')
      .replaceAll(/<\/p>/gim, '')
      .trim()
    const iconPattern =
      /^\s*\[icon:(https?:\/\/[^\s,]+?)(?:,width=(\d+(?:px|em|%)))?(?:,height=(\d+(?:px|em|%)))?\](.*)/ms

    const iconMatch = iconPattern.exec(innerText)

    if (iconMatch) {
      const [_, iconUrl, width, height, text] = iconMatch
      const remainingText = text.trim()

      let iconStyle = `background-image: url(${iconUrl}); display: inline-block; vertical-align: middle; background-size: contain; background-repeat: no-repeat;`

      let baseWidth = '30px'
      let baseHeight = '30px'

      if (width) {
        baseWidth = width
      }
      if (height) {
        baseHeight = height
      }

      iconStyle += `width: ${baseWidth};`
      iconStyle += `height: ${baseHeight};`

      return `
        <li class="markdown-icon-bullet-item">
          <span class="markdown-icon-bullet" style="${iconStyle}"></span>
          <span>${remainingText}</span>
        </li>
      `
    }

    const detailsPattern = /^\[details:(.+?)\](.+)\[\/details\]$/ms
    const detailsMatch = detailsPattern.exec(innerText)

    if (detailsMatch) {
      const [_, summaryText, detailsContent] = detailsMatch
      return `
        <li>
          <details>
            <summary>${summaryText.trim()}</summary>
            ${detailsContent.trim()}
          </details>
        </li>
      `
    }

    return `<li>${innerText}</li>`
  },
}
